import { useListDependents } from '@/api/accounting-dealer/company/partner/list-dependents'
import { InfoItem } from '@/components'
import { PersonCard } from '@/components/partner'
import { AddDependantDialog } from '@/components/partner/dependants'
import { useCompany } from '@/context/companies'
import { formatDate } from '@/helpers'
import { Dependent, DependentTypeLabelsEnum } from '@/types'
import { Add } from '@mui/icons-material'
import { Button, Skeleton, Stack } from '@mui/material'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

export function PartnerDependantsPage() {
  const { partner_key } = useParams()
  const { company } = useCompany()
  const [isOpen, setIsOpen] = useState(false)
  const [selectedDependent, setSelectedDependent] = useState<Dependent | null>(
    null,
  )

  const handleCloseDialog = () => {
    setIsOpen(false)
    setSelectedDependent(null)
  }

  const handleDependentClick = (dependent: Dependent) => {
    setSelectedDependent(dependent)
    setIsOpen(true)
  }

  const handleAddDependentClick = () => {
    setSelectedDependent(null)
    setIsOpen(true)
  }

  const { data: dependents, isLoading: isReadingDependents } =
    useListDependents({
      companyKey: company.key,
      partnerKey: partner_key!,
    })

  if (isReadingDependents) {
    return (
      <Stack spacing={2} sx={{ mb: 3 }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} variant="rounded" height={130} />
        ))}
      </Stack>
    )
  }

  return (
    <>
      <Stack spacing={2} sx={{ mb: 3 }}>
        {dependents?.map((dependent) => (
          <PersonCard
            key={dependent.key}
            name={dependent.name ?? ''}
            onClick={() => handleDependentClick(dependent)}
          >
            <Stack>
              <InfoItem
                label="Data de nascimento"
                value={formatDate(dependent.birthdate!)}
                variant="body2"
              />
              <InfoItem
                label="Tipo de dependente"
                value={DependentTypeLabelsEnum[dependent.type]}
                variant="body2"
              />
              <InfoItem
                label="Dedução de IRRF"
                value={dependent.irrf_deduction ? 'Sim' : 'Não'}
                variant="body2"
              />
            </Stack>
          </PersonCard>
        ))}
      </Stack>

      <Button
        variant="outlined"
        startIcon={<Add />}
        fullWidth
        onClick={handleAddDependentClick}
      >
        Adicionar dependente
      </Button>

      <AddDependantDialog
        open={isOpen}
        onClose={handleCloseDialog}
        dependent={selectedDependent}
      />
    </>
  )
}
